<template>
  <!-- 成本分析主容器 -->
  <div class="cost-analysis-container">
    <!-- 页面头部：标题和账务期选择器 -->
    <div class="header">
      <h2>成本分析</h2>
      <div class="base-flex">
        <div class="period-selector base-margin__right-20">
          <span>云环境：</span>
          <!-- 账务期选择下拉框 -->
          <el-select
            v-model="cloudEnvironmentValue"
            @change="changeCloudEnvironmentValue"
            placeholder="请选择云环境"
            class="base-width__200"
          >
            <el-option
              v-for="item in cloudEnvironmentList"
              :key="item.Provider"
              :label="providerList[item.Provider]"
              :value="item.Provider"
            />
          </el-select>
        </div>
        <div class="period-selector">
          <span>账务期：</span>
          <!-- 账务期选择下拉框 -->
          <!--<el-select-->
          <!--  v-model="selectedPeriod"-->
          <!--  placeholder="请选择账务期"-->
          <!--  @change="changeCloudEnvironment"-->
          <!--  class="base-width__200"-->
          <!--&gt;-->
          <!--  <el-option v-for="period in periods" :key="period" :label="period" :value="period" />-->
          <!--</el-select>-->
          <el-date-picker
            class="base-width__200"
            type="month"
            placeholder="请选择账务期"
            value-format="yyyy-MM"
            v-model="selectedPeriod"
            :picker-options="pickerOptions"
            @change="changeDatePicker"
          >
          </el-date-picker>
        </div>
      </div>
    </div>

    <!-- 主要内容区域：使用网格布局分为左右两部分 -->
    <div class="content" v-loading="echartsBoxLoading">
      <el-row :gutter="20">
        <el-col :span="18">
          <!-- 左侧面板：显示月趋势图表 -->
          <div class="left-panel">
            <div class="card">
              <!-- 图表标题区域 -->
              <div class="card-header base-flex">
                <h3>月趋势图</h3>
                <el-button-group class="base-margin__left-8">
                  <el-button
                    size="mini"
                    :type="trackBackPeriod === 'halfYear' ? 'primary' : ''"
                    @click="changeTrackBackPeriod('halfYear')"
                    >半年</el-button
                  >
                  <el-button
                    size="mini"
                    :type="trackBackPeriod === 'oneYear' ? 'primary' : ''"
                    @click="changeTrackBackPeriod('oneYear')"
                    >一年</el-button
                  >
                </el-button-group>
              </div>
              <!-- ECharts图表容器 -->
              <div class="chart-container">
                <div ref="trendChart" style="width: 100%; height: 300px"></div>
              </div>
            </div>

            <!-- 费用明细表格容器 -->
            <div class="table-wrapper">
              <div class="table-container">
                <el-table v-loading="tableLoading" :data="tableData" border height="100%" style="width: 100%">
                  <el-table-column prop="billingCycle" label="账务账期" width="100" align="center" fixed />
                  <el-table-column prop="expenseDate" label="消费日期" width="120" align="center" />
                  <el-table-column prop="accountName" label="归属账号" width="120" align="center" />
                  <el-table-column prop="productName" label="产品" width="120" align="center" />
                  <el-table-column prop="resourceType" label="资源类型" width="120" align="center" />
                  <el-table-column prop="billingMode" label="计费模式" width="100" align="center" />
                  <el-table-column prop="billingItem" label="计费项" width="120" align="center" />
                  <el-table-column prop="usageDuration" label="使用时长" width="100" align="center" />
                  <el-table-column prop="durationUnit" label="时长单位" width="100" align="center" />
                  <el-table-column prop="instanceId" label="实例ID" width="120" align="center" />
                  <el-table-column prop="instanceName" label="实例名称" width="120" align="center" />
                  <el-table-column prop="region" label="地域" width="100" align="center" />
                  <el-table-column prop="zone" label="可用区" width="100" align="center" />
                  <el-table-column prop="unitPrice" label="单价" width="100" align="center" />
                  <el-table-column prop="priceUnit" label="单价单位" width="100" align="center" />
                  <el-table-column prop="originalAmount" label="原价" width="100" align="center" />
                  <el-table-column prop="discountAmount" label="优惠金额" width="100" align="center" />
                  <el-table-column prop="couponAmount" label="代金券抵扣" width="100" align="center" />
                  <el-table-column prop="finalAmount" label="实付金额" width="100" align="center" fixed="right" />
                </el-table>
                <el-pagination
                  :current-page="currentPage"
                  :page-size="pageSize"
                  :page-sizes="[10, 20, 50, 100]"
                  :total="total"
                  align="right"
                  class="base-margin__top-10"
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <!-- 右侧面板：显示汇总信息和费用分布 -->
          <div class="right-panel">
            <!-- 汇总信息卡片 -->
            <div class="summary-card">
              <div class="summary-header">
                <h3>汇总信息</h3>
              </div>
              <div class="summary-content">
                <!-- 总金额显示区域 -->
                <div class="total-amount base-flex__between">
                  <span>
                    <span class="amount-label">原始金额</span>
                    <span class="amount-value">¥{{ monthInfo?.totalOriginalBillAmount || 0 }}</span>
                  </span>
                  <span>
                    <span class="amount-label">抵扣金额</span>
                    <span class="amount-value">¥{{ monthInfo?.totalSavedAmount || 0 }}</span>
                  </span>
                  <span>
                    <span class="amount-label">应付金额</span>
                    <span class="amount-value">¥{{ monthInfo?.totalPayableAmount || 0 }}</span>
                  </span>
                </div>
                <!-- 账号信息区域 -->
                <div class="account-info">
                  <!--<div class="info-item">-->
                  <!--  <span class="label">昨日账号：</span>-->
                  <!--  <span class="value">123456789</span>-->
                  <!--</div>-->
                  <div class="info-item">
                    <span class="label">Payer账号：</span>
                    <span class="value">{{ payerAccount }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 费用分布卡片 -->
            <div class="distribution-card">
              <div class="distribution-header">
                <h3>费用详情</h3>
              </div>
              <div class="distribution-content">
                <!-- 饼图容器 -->
                <div class="chart-container">
                  <div ref="pieChart" style="width: 100%; height: 250px"></div>
                </div>
                <!-- 费用分布列表 -->
                <div class="distribution-list">
                  <!-- 遍历显示各项费用 -->
                  <div v-for="item in monthInfo.productSummary" :key="item.productEn" class="distribution-item">
                    <span class="item-name">{{ item.productZh }}</span>
                    <span class="item-amount">{{ item.amount }}</span>
                    <!--<span class="item-percentage">{{ item.percentage }}</span>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { postRequest } from '@/common/libs/request';
import { mapGetters, mapState } from 'vuex';
import dayjs from 'dayjs';

/**
 * 成本分析组件
 * 功能：展示多云集群的成本分析数据，包括月趋势图和费用分布
 */
export default {
  name: 'CostAnalysis',

  /**
   * 组件数据定义
   */
  data() {
    return {
      // 当前选中的账务期
      selectedPeriod: dayjs().format('YYYY-MM'),

      // 可选择的账务期列表

      // ECharts图表实例
      trendChart: null, // 月趋势图实例
      pieChart: null, // 饼图实例

      // 月趋势数据：各月份的应付金额
      monthlyTrendData: [],

      // 账单周期列表
      trackBackPeriodList: [
        { label: '半年', value: 'halfYear' },
        { label: '一年', value: 'oneYear' },
      ],

      trackBackPeriod: 'oneYear',

      cloudEnvironmentList: [], // 云环境列表
      cloudEnvironmentValue: '', // 云环境
      providerList: {
        aliyun: this.$t('multiCloudCluster.aliyun'),
        huaweicloud: this.$t('multiCloudCluster.huaweicloud'),
        volcengine: this.$t('multiCloudCluster.volcengine'),
      },

      echartsBoxLoading: false,
      payerAccount: '123456789',
      monthInfo: {},
      // 日期选择器配置
      pickerOptions: {
        disabledDate: (time) => {
          // 获取当前日期
          const currentDate = new Date();
          // 获取当前月份的第一天
          const currentMonthStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
          // 禁用当前月份之后的日期
          return time.getTime() > currentMonthStart.getTime();
        },
      },

      // 表格相关数据
      tableLoading: false, // 表格加载状态
      tableData: [], // 表格数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页大小
      total: 0, // 总数据量,

      // 字段映射配置 - 统一不同云环境的字段格式
      fieldMappingConfig: {
        // 阿里云字段映射
        aliyun: {
          billingCycle: 'SplitBillingCycle',
          expenseDate: 'SplitBillingDate',
          accountName: 'BillAccountName',
          productName: 'ProductName',
          resourceType: 'BillingItem',
          billingMode: 'SubscriptionType',
          billingItem: 'ProductDetail',
          usageDuration: 'ServicePeriod',
          durationUnit: 'ServicePeriodUnit',
          instanceId: 'InstanceID',
          instanceName: 'NickName',
          region: 'Region',
          zone: 'Zone',
          unitPrice: 'ListPrice',
          priceUnit: 'ListPriceUnit',
          originalAmount: 'PretaxGrossAmount',
          discountAmount: 'InvoiceDiscount',
          couponAmount: 'DeductedByCoupons',
          finalAmount: 'AfterDiscountAmount',
        },
        // 华为云字段映射
        huaweicloud: {
          billingCycle: 'cycle',
          expenseDate: 'bill_date',
          accountName: 'customer_id',
          productName: 'cloud_service_type_name',
          resourceType: 'resource_type_name',
          billingMode: 'charge_mode',
          billingItem: 'product_spec_desc',
          usageDuration: 'usage',
          durationUnit: 'usage_measure_id',
          instanceId: 'res_instance_id',
          instanceName: 'resource_name',
          region: 'region_name',
          zone: 'az_code_infos[0].az_code',
          unitPrice: 'unit_price',
          priceUnit: 'unit',
          originalAmount: 'official_amount',
          discountAmount: 'discount_amount',
          couponAmount: 'coupon_amount',
          finalAmount: 'consume_amount',
        },
        // 火山云字段映射
        volcengine: {
          billingCycle: 'BillPeriod',
          expenseDate: 'ExpenseDate',
          accountName: 'OwnerUserName',
          productName: 'ProductZh',
          resourceType: 'Element',
          billingMode: 'BillingMode',
          billingItem: 'Factor',
          usageDuration: 'UseDuration',
          durationUnit: 'UseDurationUnit',
          instanceId: 'InstanceNo',
          instanceName: 'InstanceName',
          region: 'Region',
          zone: 'Zone',
          unitPrice: 'Price',
          priceUnit: 'PriceUnit',
          originalAmount: 'OriginalBillAmount',
          discountAmount: 'PreferentialBillAmount',
          couponAmount: 'CouponAmount',
          finalAmount: 'RoundAmount',
        },
      },
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'() {
      this.getMultiCloudAccountList();
    },
  },

  created() {
    this.getMultiCloudAccountList();
  },

  /**
   * 组件挂载后执行
   * 初始化图表并监听窗口大小变化
   */
  mounted() {
    this.initCharts();
    // 监听窗口大小变化事件，用于图表自适应
    window.addEventListener('resize', this.handleResize);
  },

  /**
   * 组件销毁前执行
   * 清理图表实例和事件监听器，防止内存泄漏
   */
  beforeDestroy() {
    // 销毁趋势图实例
    if (this.trendChart) {
      this.trendChart.dispose();
    }
    // 销毁饼图实例
    if (this.pieChart) {
      this.pieChart.dispose();
    }
    // 移除窗口大小变化事件监听器
    window.removeEventListener('resize', this.handleResize);
  },

  /**
   * 组件方法定义
   */
  methods: {
    /**
     * 获取云环境列表
     */
    async getMultiCloudAccountList() {
      const data = {
        offset: 0,
        limit: 999,
      };
      this.echartsBoxLoading = true;
      this.tableLoading = true;

      try {
        const res = await postRequest('/api/eda/common/multicloud/describeMultiCloudAccountList', data);

        if (res.total === 0) {
          this.$message.warning('当前项目没有云环境！需要创建云环境后才能使用账单统计功能！');
          this.monthlyTrendData = [];
          this.monthInfo = [];
          this.payerAccount = '';
          this.cloudEnvironmentList = [];
          this.cloudEnvironmentValue = '';
          this.echartsBoxLoading = false;
          this.tableLoading = false;
          this.initCharts();
          return;
        }

        this.cloudEnvironmentValue = res?.list[0]?.Provider || '';
        this.cloudEnvironmentList = res?.list || [];

        // 统一执行：先切换云环境（包含获取账单详情）
        await this.changeCloudEnvironment();
      } catch (error) {
        this.echartsBoxLoading = false;
        this.tableLoading = false;
      }
    },

    /**
     * 切换日期选择器
     */
    async changeDatePicker(type) {
      this.selectedPeriod = type;
      this.echartsBoxLoading = true;
      this.tableLoading = true;

      // 统一执行：先切换云环境（包含获取账单详情）
      await this.changeCloudEnvironment();
    },

    /**
     * 切换云环境
     */
    async changeCloudEnvironmentValue(val) {
      this.cloudEnvironmentValue = val;
      this.echartsBoxLoading = true;
      this.tableLoading = true;

      // 统一执行：先切换云环境（包含获取账单详情）
      await this.changeCloudEnvironment();
    },

    /**
     * 切换回溯周期
     */
    changeTrackBackPeriod(type) {
      this.trackBackPeriod = type;
      this.changeCloudEnvironment();
    },

    /**
     * 切换云环境 参数
     */
    async changeCloudEnvironment() {
      this.echartsBoxLoading = true;
      this.tableLoading = true;

      try {
        // 切换云环境时先清空之前的数据，避免数据残留
        this.monthInfo = {};
        this.tableData = [];
        this.total = 0;

        // 执行云环境切换逻辑
        const params = {
          region: 'ap-guangzhou',
          billingPeriod: this.selectedPeriod,
          trackBackPeriod: this.trackBackPeriod,
          verbose: true,
        };

        switch (this.cloudEnvironmentValue) {
          case 'aliyun':
            await this.aliyunDescribeSplitItemBill(params, '');
            break;
          case 'volcengine':
            await this.volcengineListBillDetail(params, '');
            break;
          case 'huaweicloud':
            await this.huaweicloudListCustomerselfResourceRecordDetails(params, '');
            break;
        }

        // 图表数据加载完成，关闭图表loading
        this.echartsBoxLoading = false;

        // 获取详细账单数据（表格数据）
        await this.getBillDetail(this.selectedPeriod);
      } catch (error) {
        console.error('切换云环境失败:', error);
        this.echartsBoxLoading = false;
        this.tableLoading = false;
      }
    },

    /**
     * 获取月份账单详情
     */
    async getBillDetail(time) {
      const params = {
        region: 'ap-guangzhou',
        billingPeriod: time,
        verbose: true,
      };

      try {
        switch (this.cloudEnvironmentValue) {
          case 'aliyun':
            await this.aliyunDescribeSplitItemBillDetail(params);
            break;
          case 'volcengine':
            await this.volcengineListBillDetailDetail(params);
            break;
          case 'huaweicloud':
            await this.huaweicloudListCustomerselfResourceRecordDetailsDetail(params);
            break;
        }
      } catch (error) {
        console.error('获取账单详情失败:', error);
        // 发生错误时，确保清空表格数据
        this.tableData = [];
        this.total = 0;
      } finally {
        // 表格数据加载完成，关闭表格loading
        this.tableLoading = false;
      }
    },

    /**
     * 公共方法：处理账单数据
     * @param {Object} res - 账单API响应数据
     */
    handleBillData(res) {
      const list
        = res.items
          .map((item) => {
            if (item.productSummary.length !== 0) {
              item.productSummary.map((info) => {
                info.name = info.productZh;
                info.value = info.amount;
              });
            }
            return item;
          })
          .filter(Boolean) || [];

      this.monthlyTrendData = list || [];

      // 查找当前选中账务期的数据
      const currentMonthData = list.filter(item => item.billingPeriod === this.selectedPeriod)[0];

      // 只有当没有当前月份数据或数据需要更新时才设置
      // 添加云环境检查，确保数据与当前云环境匹配
      if (!this.monthInfo || this.monthInfo.billingPeriod !== this.selectedPeriod) {
        this.monthInfo = currentMonthData;
      }

      // 设置表格数据源为res?.items[0]?.list（仅在需要时）
      // 添加云环境检查，避免不同云环境数据混淆
      if (res?.items?.[0]?.list && (!this.monthInfo.list || this.monthInfo.billingPeriod === this.selectedPeriod)) {
        this.monthInfo.list = res.items[0].list;
      }

      this.payerAccount = list[0]?.accountId || '';
      this.initCharts();
      this.updateTableData(); // 更新表格数据
    },

    /**
     * 获取阿里云 账单统计数据
     */
    aliyunDescribeSplitItemBill(params) {
      return new Promise((resolve, reject) => {
        postRequest('/api/eda/common/aliyun/describeSplitItemBill', params)
          .then((res) => {
            this.handleBillData(res);
            resolve(res);
          })
          .catch(reject);
      });
    },

    /**
     * 获取阿里云详细账单数据
     */
    aliyunDescribeSplitItemBillDetail(params) {
      return new Promise((resolve, reject) => {
        postRequest('/api/eda/common/aliyun/describeSplitItemBill', params)
          .then((res) => {
            if (res?.items?.[0]?.list) {
              // 检查当前是否已经有有效数据，避免被慢速请求覆盖
              if (!this.monthInfo.list || this.monthInfo.billingPeriod === this.selectedPeriod) {
                // 设置表格数据源为res?.items[0]?.list
                this.monthInfo.list = res.items[0].list;
                this.updateTableData(); // 更新表格数据
              }
            }
            resolve(res);
          })
          .catch(reject);
      });
    },

    /**
     * 获取华为云 账单统计数据
     */
    huaweicloudListCustomerselfResourceRecordDetails(params) {
      return new Promise((resolve, reject) => {
        postRequest('/api/eda/common/huaweicloud/listCustomerselfResourceRecordDetails', params)
          .then((res) => {
            this.handleBillData(res);
            resolve(res);
          })
          .catch(reject);
      });
    },

    /**
     * 获取华为云详细账单数据
     */
    huaweicloudListCustomerselfResourceRecordDetailsDetail(params) {
      return new Promise((resolve, reject) => {
        postRequest('/api/eda/common/huaweicloud/listCustomerselfResourceRecordDetails', params)
          .then((res) => {
            if (res?.items?.[0]?.list) {
              // 检查当前是否已经有有效数据，避免被慢速请求覆盖
              if (!this.monthInfo.list || this.monthInfo.billingPeriod === this.selectedPeriod) {
                // 设置表格数据源为res?.items[0]?.list
                this.monthInfo.list = res.items[0].list;
                this.updateTableData(); // 更新表格数据
              }
            }
            resolve(res);
          })
          .catch(reject);
      });
    },

    /**
     * 获取火山云 账单统计数据
     */
    volcengineListBillDetail(params) {
      return new Promise((resolve, reject) => {
        postRequest('/api/eda/common/volcengine/listBillDetail', params)
          .then((res) => {
            this.handleBillData(res);
            resolve(res);
          })
          .catch(reject);
      });
    },

    /**
     * 获取火山云详细账单数据
     */
    volcengineListBillDetailDetail(params) {
      return new Promise((resolve, reject) => {
        postRequest('/api/eda/common/volcengine/listBillDetail', params)
          .then((res) => {
            if (res?.items?.[0]?.list) {
              // 检查当前是否已经有有效数据，避免被慢速请求覆盖
              if (!this.monthInfo.list || this.monthInfo.billingPeriod === this.selectedPeriod) {
                // 设置表格数据源为res?.items[0]?.list
                this.monthInfo.list = res.items[0].list;
                this.updateTableData(); // 更新表格数据
              }
            }
            resolve(res);
          })
          .catch(reject);
      });
    },

    /**
     * 初始化所有图表
     */
    initCharts() {
      // 先销毁所有现有图表实例，避免重复初始化错误
      if (this.trendChart) {
        this.trendChart.dispose();
      }
      if (this.pieChart) {
        this.pieChart.dispose();
      }

      this.initTrendChart();
      this.initPieChart();
    },

    /**
     * 初始化月趋势折线图
     * 展示应付金额的月度变化趋势
     */
    initTrendChart() {
      // 获取图表DOM元素
      const chartDom = this.$refs.trendChart;

      // 如果已存在图表实例，先销毁再重新初始化
      if (this.trendChart) {
        this.trendChart.dispose();
      }

      this.trendChart = this.$echarts.init(chartDom);

      // 配置图表选项
      const option = {
        // 图表标题配置
        title: {
          text: '应付金额月趋势',
          left: 'center',
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal',
          },
        },
        // 提示框配置
        tooltip: {
          trigger: 'axis', // 坐标轴触发
          formatter: '{b}<br/>{a}: {c}元', // 格式化提示内容
        },
        // X轴配置：月份数据
        xAxis: {
          type: 'category', // 类目轴
          data: this.monthlyTrendData.map(item => item.billingPeriod).reverse(), // 月份数据
          axisLabel: {
            rotate: 45, // 标签旋转45度防止重叠
          },
        },
        // Y轴配置：金额数值
        yAxis: {
          type: 'value', // 数值轴
          name: '金额(元)', // 轴名称
        },
        // 数据系列配置
        series: [
          {
            name: '应付金额',
            type: 'bar', // 柱状图
            data: this.monthlyTrendData.map(item => item.totalOriginalBillAmount).reverse(), // 金额数据
            itemStyle: {
              color: '#50a4f1', // 数据点颜色
            },
            // 面积填充样式
            areaStyle: {
              color: {
                type: 'linear', // 线性渐变
                x: 0,
                y: 0,
                x2: 0,
                y2: 1, // 渐变方向从上到下
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(24, 144, 255, 0.3)', // 顶部颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(24, 144, 255, 0.05)', // 底部颜色
                  },
                ],
              },
            },
          },
        ],
        // 图表网格配置
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          top: '15%',
          containLabel: true, // 包含坐标轴标签
        },
      };

      // 应用图表配置
      this.trendChart.setOption(option);

      // 添加柱状图点击事件监听
      this.trendChart.on('click', (params) => {
        this.handleBarClick(params);
      });
    },

    /**
     * 处理柱状图点击事件
     * @param {Object} params - ECharts点击事件参数
     */
    handleBarClick(params) {
      if (params.componentType === 'series' && params.seriesType === 'bar') {
        // 获取点击的柱子索引
        const { dataIndex } = params;
        // 获取对应的月份数据
        const monthData = this.monthlyTrendData[this.monthlyTrendData.length - 1 - dataIndex];

        if (monthData) {
          // 设置表格loading状态
          this.tableLoading = true;

          // 更新当前月份信息为点击的月份数据
          this.monthInfo = monthData;

          // 如果没有详细数据，则获取详细账单数据
          if (!(monthData.list && monthData.list.length > 0)) {
            this.getBillDetail(monthData.billingPeriod);
          } else {
            // 如果已有数据，直接更新表格并关闭loading
            this.updateTableData();
            this.tableLoading = false;
          }

          // 重新渲染饼图，显示当前点击月份的费用分布
          this.initPieChart();

          // console.log('点击的柱子信息：', monthData);
        }
      }
    },

    /**
     * 初始化费用分布饼图
     * 展示各项费用的占比分布情况
     */
    initPieChart() {
      // 获取图表DOM元素
      const chartDom = this.$refs.pieChart;

      // 如果已存在图表实例，先销毁再重新初始化
      if (this.pieChart) {
        this.pieChart.dispose();
      }

      this.pieChart = this.$echarts.init(chartDom);

      // // 饼图数据定义
      // const pieData = this.monthInfo.productSummary || [];

      // 饼图数据定义
      const pieData = this.monthInfo.productSummary || [];

      // 配置饼图选项
      const option = {
        // 提示框配置
        tooltip: {
          trigger: 'item', // 数据项触发
          formatter: '{a} <br/>{b}: {c}元 ({d}%)', // 格式化提示内容
        },
        // 图例配置
        legend: {
          left: 'center',

          // orient: 'vertical', // 垂直排列
          // // right: 4, // 距离右侧4px
          // top: 'center', // 垂直居中
          // // 图例格式化函数
          // formatter(productZh) {
          //   return productZh;
          // },
        },
        // 数据系列配置
        series: [
          {
            name: '费用分布',
            type: 'pie', // 饼图类型
            radius: ['40%', '70%'], // 内外半径（环形饼图）
            center: ['50%', '50%'], // 饼图中心位置
            avoidLabelOverlap: false, // 避免标签重叠
            // 数据项样式
            itemStyle: {
              borderRadius: 10, // 圆角边框
              borderColor: '#fff', // 边框颜色
              borderWidth: 2, // 边框宽度
            },
            // 标签配置
            label: {
              show: false, // 默认不显示标签
              position: 'center', // 标签位置居中
            },
            // 高亮状态配置
            emphasis: {
              label: {
                show: true, // 高亮时显示标签
                fontSize: '12',
                fontWeight: 'bold',
                formatter: '{b}\n{c}元 ({d}%)', // 标签格式化
              },
            },
            labelLine: {
              show: false, // 不显示标签引导线
            },
            data: pieData, // 饼图数据
          },
        ],
      };

      // 应用图表配置
      this.pieChart.setOption(option);
    },

    /**
     * 处理每页大小变化
     * @param {number} size - 新的每页大小
     */
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.updateTableData();
    },

    /**
     * 处理页码变化
     * @param {number} page - 新的页码
     */
    handleCurrentChange(page) {
      this.currentPage = page;
      this.updateTableData();
    },

    /**
     * 更新表格数据
     */
    updateTableData() {
      if (!this.monthInfo || !this.monthInfo.list) {
        this.tableData = [];
        this.total = 0;
        return;
      }

      const allData = this.monthInfo.list.map((item) => {
        // 统一格式化字段
        const formattedItem = this.formatTableItem(item);
        return {
          ...formattedItem,
          billingPeriod: this.selectedPeriod,
          percentage: item.percentage || ((item.amount / this.monthInfo.totalPayableAmount) * 100).toFixed(2),
        };
      });

      this.total = allData.length;

      // 分页处理
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      this.tableData = allData.slice(startIndex, endIndex);
    },

    /**
     * 统一格式化表格数据项
     * @param {Object} item - 原始数据项
     * @returns {Object} - 格式化后的数据项
     */
    formatTableItem(item) {
      switch (this.cloudEnvironmentValue) {
        case 'aliyun':
          return this.formatAliyunItem(item);
        case 'huaweicloud':
          return this.formatHuaweicloudItem(item);
        case 'volcengine':
          return this.formatVolcengineItem(item);
        default:
          return this.formatDefaultItem(item);
      }
    },

    /**
     * 格式化阿里云数据项
     * @param {Object} item - 阿里云原始数据项
     * @returns {Object} - 格式化后的数据项
     */
    // eslint-disable-next-line complexity
    formatAliyunItem(item) {
      const mappingConfig = this.fieldMappingConfig.aliyun || {};
      const formattedItem = {};

      // 1. 账务账期字段映射
      formattedItem.billingCycle = item[mappingConfig.billingCycle] || item.billingCycle || item.bill_cycle;

      // 2. 消费日期字段映射 - 阿里云特殊处理
      if (mappingConfig.expenseDate && item[mappingConfig.expenseDate]) {
        formattedItem.expenseDate = this.formatDate(item[mappingConfig.expenseDate]);
      } else if (!item[mappingConfig.expenseDate] && item.SplitBillingCycle) {
        // 阿里云特殊处理：当SplitBillingDate为空时，从SplitBillingCycle生成首日
        const billingCycle = item.SplitBillingCycle;
        if (billingCycle && billingCycle.match(/^\d{4}-\d{2}$/)) {
          formattedItem.expenseDate = `${billingCycle}-01`; // 生成YYYY-MM-01格式
        } else {
          formattedItem.expenseDate = this.formatDate(billingCycle);
        }
      } else if (item.UsageStartTime) {
        formattedItem.expenseDate = this.formatDate(item.UsageStartTime);
      }

      // 3. 归属账号字段映射
      formattedItem.accountName = item[mappingConfig.accountName] || item.PayerAccount;

      // 4. 产品名称字段映射
      formattedItem.productName = item[mappingConfig.productName] || item.productZh || item.ProductName;

      // 5. 资源类型字段映射
      formattedItem.resourceType = item[mappingConfig.resourceType] || item.Element || item.BillingItem;

      // 6. 计费模式字段映射
      const billingMode = item[mappingConfig.billingMode] || item.BillingMode || item.SubscriptionType;
      formattedItem.billingMode = this.formatBillingMode(billingMode);

      // 7. 计费项字段映射
      formattedItem.billingItem = item[mappingConfig.billingItem] || item.Factor || item.ProductDetail;

      // 8. 使用时长字段映射
      formattedItem.usageDuration = item[mappingConfig.usageDuration] || item.UseDuration || item.ServicePeriod;

      // 9. 时长单位字段映射
      formattedItem.durationUnit = item[mappingConfig.durationUnit] || item.UseDurationUnit || item.ServicePeriodUnit;

      // 10. 实例ID字段映射
      formattedItem.instanceId = item[mappingConfig.instanceId] || item.InstanceID || item.InstanceNo;

      // 11. 实例名称字段映射
      formattedItem.instanceName = item[mappingConfig.instanceName] || item.NickName || item.InstanceName;

      // 12. 地域字段映射
      formattedItem.region = item[mappingConfig.region] || item.Region;

      // 13. 可用区字段映射
      formattedItem.zone = item[mappingConfig.zone] || item.Zone;

      // 14. 单价字段映射
      const unitPrice = item[mappingConfig.unitPrice] || item.Price || item.ListPrice;
      formattedItem.unitPrice = this.formatAmount(unitPrice);

      // 15. 单价单位字段映射
      formattedItem.priceUnit = item[mappingConfig.priceUnit] || item.PriceUnit;

      // 16. 原价字段映射
      const originalAmount = item[mappingConfig.originalAmount] || item.amount || item.PretaxGrossAmount;
      formattedItem.originalAmount = this.formatAmount(originalAmount);

      // 17. 优惠金额字段映射
      const discountAmount = item[mappingConfig.discountAmount] || item.InvoiceDiscount || item.PreferentialBillAmount;
      formattedItem.discountAmount = this.formatAmount(discountAmount);

      // 18. 代金券抵扣字段映射
      const couponAmount = item[mappingConfig.couponAmount] || item.DeductedByCoupons || item.CouponAmount;
      formattedItem.couponAmount = this.formatAmount(couponAmount);

      // 19. 实付金额字段映射
      const finalAmount = item[mappingConfig.finalAmount] || item.RoundAmount || item.AfterDiscountAmount;
      formattedItem.finalAmount = this.formatAmount(finalAmount);

      // 保留原始数据用于调试
      formattedItem._rawData = item;

      return formattedItem;
    },

    /**
     * 格式化华为云数据项
     * @param {Object} item - 华为云原始数据项
     * @returns {Object} - 格式化后的数据项
     */
    // eslint-disable-next-line complexity
    formatHuaweicloudItem(item) {
      const mappingConfig = this.fieldMappingConfig.huaweicloud || {};
      const formattedItem = {};

      // 1. 账务账期字段映射
      formattedItem.billingCycle = item[mappingConfig.billingCycle] || item.cycle;

      // 2. 消费日期字段映射
      if (mappingConfig.expenseDate && item[mappingConfig.expenseDate]) {
        formattedItem.expenseDate = this.formatDate(item[mappingConfig.expenseDate]);
      } else if (item.bill_date) {
        formattedItem.expenseDate = this.formatDate(item.bill_date);
      } else if (item.usage_start_time) {
        formattedItem.expenseDate = this.formatDate(item.usage_start_time);
      }

      // 3. 归属账号字段映射
      formattedItem.accountName = item[mappingConfig.accountName] || item.customer_id;

      // 4. 产品名称字段映射
      formattedItem.productName = item[mappingConfig.productName] || item.cloud_service_type_name;

      // 5. 资源类型字段映射
      formattedItem.resourceType = item[mappingConfig.resourceType] || item.resource_type_name;

      // 6. 计费模式字段映射 - 华为云特殊处理
      const billingMode = item[mappingConfig.billingMode] || item.charge_mode;
      if (billingMode === 1) {
        formattedItem.billingMode = '包年包月';
      } else if (billingMode === 3) {
        formattedItem.billingMode = '按量计费';
      } else {
        formattedItem.billingMode = this.formatBillingMode(billingMode);
      }

      // 7. 计费项字段映射
      formattedItem.billingItem = item[mappingConfig.billingItem] || item.usage_type;

      // 8. 使用时长字段映射 - 华为云特殊处理
      const usageDuration = item[mappingConfig.usageDuration] || item.usage;
      formattedItem.usageDuration = usageDuration ? this.formatAmount(usageDuration) : ' - ';

      // 9. 时长单位字段映射 - 华为云特殊处理
      const durationUnit = item[mappingConfig.durationUnit] || item.usage_measure_id;
      formattedItem.durationUnit = durationUnit || ' - ';

      // 10. 实例ID字段映射
      formattedItem.instanceId = item[mappingConfig.instanceId] || item.res_instance_id;

      // 11. 实例名称字段映射
      formattedItem.instanceName = item[mappingConfig.instanceName] || item.resource_name;

      // 12. 地域字段映射
      formattedItem.region = item[mappingConfig.region] || item.region_name;

      // 13. 可用区字段映射 - 华为云需要提取数组第一个元素
      if (mappingConfig.zone && item[mappingConfig.zone]) {
        formattedItem.zone = item[mappingConfig.zone];
      } else if (item.az_code_infos && Array.isArray(item.az_code_infos) && item.az_code_infos.length > 0) {
        formattedItem.zone = item.az_code_infos[0].az_code;
      }

      // 14. 单价字段映射 - 华为云特殊处理
      const unitPrice = item[mappingConfig.unitPrice] || item.unit_price;
      formattedItem.unitPrice = unitPrice ? this.formatAmount(unitPrice) : ' - ';

      // 15. 单价单位字段映射 - 华为云特殊处理
      const priceUnit = item[mappingConfig.priceUnit] || item.unit;
      formattedItem.priceUnit = priceUnit || ' - ';

      // 16. 原价字段映射
      const originalAmount = item[mappingConfig.originalAmount] || item.official_amount;
      formattedItem.originalAmount = this.formatAmount(originalAmount);

      // 17. 优惠金额字段映射
      const discountAmount = item[mappingConfig.discountAmount] || item.discount_amount;
      formattedItem.discountAmount = this.formatAmount(discountAmount);

      // 18. 代金券抵扣字段映射
      const couponAmount = item[mappingConfig.couponAmount] || item.coupon_amount;
      formattedItem.couponAmount = this.formatAmount(couponAmount);

      // 19. 实付金额字段映射
      const finalAmount = item[mappingConfig.finalAmount] || item.consume_amount;
      formattedItem.finalAmount = this.formatAmount(finalAmount);

      // 保留原始数据用于调试
      formattedItem._rawData = item;

      return formattedItem;
    },

    /**
     * 格式化火山云数据项
     * @param {Object} item - 火山云原始数据项
     * @returns {Object} - 格式化后的数据项
     */
    formatVolcengineItem(item) {
      const mappingConfig = this.fieldMappingConfig.volcengine || {};
      const formattedItem = {};

      // 1. 账务账期字段映射
      formattedItem.billingCycle = item[mappingConfig.billingCycle] || item.BillPeriod;

      // 2. 消费日期字段映射
      if (mappingConfig.expenseDate && item[mappingConfig.expenseDate]) {
        formattedItem.expenseDate = this.formatDate(item[mappingConfig.expenseDate]);
      } else if (item.ExpenseDate) {
        formattedItem.expenseDate = this.formatDate(item.ExpenseDate);
      }

      // 3. 归属账号字段映射
      formattedItem.accountName = item[mappingConfig.accountName] || item.OwnerUserName;

      // 4. 产品名称字段映射
      formattedItem.productName = item[mappingConfig.productName] || item.ProductZh;

      // 5. 资源类型字段映射
      formattedItem.resourceType = item[mappingConfig.resourceType] || item.Element;

      // 6. 计费模式字段映射
      const billingMode = item[mappingConfig.billingMode] || item.BillingMode;
      formattedItem.billingMode = this.formatBillingMode(billingMode);

      // 7. 计费项字段映射
      formattedItem.billingItem = item[mappingConfig.billingItem] || item.Factor;

      // 8. 使用时长字段映射 - 火山云需要单位换算
      const usageDuration = item[mappingConfig.usageDuration] || item.UseDuration;
      const durationUnit = item[mappingConfig.durationUnit] || item.UseDurationUnit;
      if (usageDuration && durationUnit) {
        formattedItem.usageDuration = this.convertUsageDuration(usageDuration, durationUnit);
      } else {
        formattedItem.usageDuration = usageDuration;
      }

      // 9. 时长单位字段映射
      formattedItem.durationUnit = item[mappingConfig.durationUnit] || item.UseDurationUnit;

      // 10. 实例ID字段映射
      formattedItem.instanceId = item[mappingConfig.instanceId] || item.InstanceNo;

      // 11. 实例名称字段映射
      formattedItem.instanceName = item[mappingConfig.instanceName] || item.InstanceName;

      // 12. 地域字段映射
      formattedItem.region = item[mappingConfig.region] || item.Region;

      // 13. 可用区字段映射
      formattedItem.zone = item[mappingConfig.zone] || item.Zone;

      // 14. 单价字段映射
      const unitPrice = item[mappingConfig.unitPrice] || item.Price;
      formattedItem.unitPrice = this.formatAmount(unitPrice);

      // 15. 单价单位字段映射
      formattedItem.priceUnit = item[mappingConfig.priceUnit] || item.PriceUnit;

      // 16. 原价字段映射
      const originalAmount = item[mappingConfig.originalAmount] || item.OriginalBillAmount;
      formattedItem.originalAmount = this.formatAmount(originalAmount);

      // 17. 优惠金额字段映射
      const discountAmount = item[mappingConfig.discountAmount] || item.PreferentialBillAmount;
      formattedItem.discountAmount = this.formatAmount(discountAmount);

      // 18. 代金券抵扣字段映射
      const couponAmount = item[mappingConfig.couponAmount] || item.CouponAmount;
      formattedItem.couponAmount = this.formatAmount(couponAmount);

      // 19. 实付金额字段映射
      const finalAmount = item[mappingConfig.finalAmount] || item.RoundAmount;
      formattedItem.finalAmount = this.formatAmount(finalAmount);

      // 保留原始数据用于调试
      formattedItem._rawData = item;

      return formattedItem;
    },

    /**
     * 默认格式化数据项（用于未知云环境）
     * @param {Object} item - 原始数据项
     * @returns {Object} - 格式化后的数据项
     */
    // eslint-disable-next-line complexity
    formatDefaultItem(item) {
      const formattedItem = {};

      // 尝试从常见字段中提取数据
      formattedItem.billingCycle = item.billingCycle || item.bill_cycle || item.BillingPeriod;
      formattedItem.expenseDate = this.formatDate(item.expenseDate || item.UsageStartTime || item.usage_start_time);
      formattedItem.accountName = item.accountName || item.PayerAccount || item.customer_id;
      formattedItem.productName = item.productName || item.productZh || item.ProductName;
      formattedItem.resourceType = item.resourceType || item.Element || item.BillingItem;
      formattedItem.billingMode = this.formatBillingMode(item.billingMode || item.BillingMode || item.SubscriptionType);
      formattedItem.billingItem = item.billingItem || item.Factor || item.ProductDetail;
      formattedItem.usageDuration = item.usageDuration || item.UseDuration || item.ServicePeriod;
      formattedItem.durationUnit = item.durationUnit || item.UseDurationUnit || item.ServicePeriodUnit;
      formattedItem.instanceId = item.instanceId || item.InstanceID || item.InstanceNo;
      formattedItem.instanceName = item.instanceName || item.NickName || item.InstanceName;
      formattedItem.region = item.region || item.Region;
      formattedItem.zone = item.zone || item.Zone;
      formattedItem.unitPrice = this.formatAmount(item.unitPrice || item.Price || item.ListPrice);
      formattedItem.priceUnit = item.priceUnit || item.PriceUnit;
      formattedItem.originalAmount = this.formatAmount(item.originalAmount || item.amount || item.PretaxGrossAmount);
      formattedItem.discountAmount = this.formatAmount(item.discountAmount || item.InvoiceDiscount || item.PreferentialBillAmount);
      formattedItem.couponAmount = this.formatAmount(item.couponAmount || item.DeductedByCoupons || item.CouponAmount);
      formattedItem.finalAmount = this.formatAmount(item.finalAmount || item.RoundAmount || item.AfterDiscountAmount);

      // 保留原始数据用于调试
      formattedItem._rawData = item;

      return formattedItem;
    },

    /**
     * 格式化计费模式
     * @param {string} billingMode - 原始计费模式值
     * @returns {string} - 格式化后的计费模式
     */
    formatBillingMode(billingMode) {
      if (!billingMode) return '';

      const modeMap = {
        PayAsYouGo: '按量计费',
        Subscription: '包年包月',
        1: '包年包月',
        3: '按量计费',
        包年包月: '包年包月',
        按量计费: '按量计费',
      };

      return modeMap[billingMode] || billingMode;
    },

    /**
     * 转换使用时长到统一单位
     * @param {number} duration - 原始时长
     * @param {string} unit - 原始单位
     * @returns {string} - 转换后的时长和单位
     */
    convertUsageDuration(duration, unit) {
      if (!duration || !unit) return duration;

      // 将各种单位转换为小时
      let hours = duration;

      switch (unit.toLowerCase()) {
        case '秒':
        case 's':
          hours = duration / 3600;
          break;
        case '分钟':
        case 'min':
          hours = duration / 60;
          break;
        case '小时':
        case 'h':
          hours = duration;
          break;
        case '天':
        case 'd':
          hours = duration * 24;
          break;
        case '月':
        case 'm':
          hours = duration * 24 * 30; // 近似值
          break;
        case '年':
        case 'y':
          hours = duration * 24 * 365; // 近似值
          break;
        default:
          return duration;
      }

      return hours.toFixed(2);
    },

    /**
     * 格式化金额
     * @param {number|string} amount - 原始金额
     * @returns {string} - 格式化后的金额
     */
    formatAmount(amount) {
      if (!amount) return '0.00';

      const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
      return numAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    /**
     * 格式化日期
     * @param {string} dateStr - 原始日期字符串
     * @returns {string} - 格式化后的日期字符串
     */
    formatDate(dateStr) {
      if (!dateStr) return '';

      try {
        // 尝试解析各种日期格式
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) {
          return dateStr; // 如果无法解析，返回原始字符串
        }

        // 格式化为 YYYY-MM-DD
        return date.toISOString().split('T')[0];
      } catch (error) {
        return dateStr; // 解析失败时返回原始字符串
      }
    },

    /**
     * 窗口大小变化处理函数
     * 当浏览器窗口大小变化时，重新调整图表大小以适应新尺寸
     */
    handleResize() {
      // 重新调整趋势图大小
      if (this.trendChart) {
        this.trendChart.resize();
      }
      // 重新调整饼图大小
      if (this.pieChart) {
        this.pieChart.resize();
      }
    },
  },
};
</script>

<!-- 组件样式定义 -->
<style scoped lang="scss">
/* 主容器样式 */
.cost-analysis-container {
  padding: 20px;
  background-color: #f5f7fa; /* 背景色 */
  min-height: 100vh; /* 最小高度为视口高度 */
}

/* 头部区域样式 */
.header {
  display: flex;
  justify-content: space-between; /* 两端对齐 */
  align-items: center;
  margin-bottom: 20px;
  background: white;
  padding: 20px;
  border-radius: 8px; /* 圆角边框 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}

.header h2 {
  margin: 0;
  color: #303133; /* 主文字颜色 */
  font-size: 20px;
}

/* 内容区域布局 */
.content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  //min-height: 1000px; /* 确保有足够高度 */
  //min-height: 1000px; /* 确保有足够高度 */
  overflow-y: auto; /* 添加垂直滚动条支持 */
  overflow-x: hidden; /* 隐藏横向滚动条 */
  max-height: calc(100vh - 330px); /* 限制最大高度为视口高度减去头部高度 */
}

/* 主内容区域布局 */
.content .el-row {
  flex: 1;
  display: flex;
  //min-height: 800px;
}

/* 左侧面板样式 */
.left-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  //min-height: 600px;
}

/* 右侧面板样式 */
.right-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  //min-height: 650px;
}

/* 卡片通用样式 */
.card,
.summary-card,
.distribution-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 柱状图卡片样式 */
.card {
  flex: 0 0 auto;
  min-height: 400px;
}

/* 表格卡片样式 */
.table-card {
  flex: 1;
  min-height: 500px;
  display: flex;
  flex-direction: column;
}

/* 汇总卡片样式 */
.summary-card {
  flex: 0 0 auto;
  min-height: 244px;
  max-height: 244px;
}

/* 饼图卡片样式 */
.distribution-card {
  flex: 1;
  min-height: 450px;
  max-height: 500px;
}

/* 卡片头部样式 */
.card-header,
.summary-header,
.distribution-header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
  background-color: #fafafa;
  flex-shrink: 0;
}

.card-header h3,
.summary-header h3,
.distribution-header h3 {
  margin: 0;
  font-size: 16px;
  color: #303133;
}

/* 图表容器样式 */
.chart-container {
  padding: 20px;
  flex: 1;
  min-height: 250px;
  max-height: 280px;
}

.summary-content {
  padding: 20px;
  flex: 1;
}

.total-amount {
  text-align: center;
  margin-bottom: 20px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  color: white;
}

.amount-label {
  display: block;
  font-size: 14px;
  margin-bottom: 8px;
  opacity: 0.9;
}

.amount-value {
  display: block;
  font-size: 28px;
  font-weight: bold;
}

.account-info {
  margin-top: 20px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #ebeef5;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item .label {
  color: #606266;
  font-size: 14px;
}

.info-item .value {
  color: #303133;
  font-weight: 500;
}

.distribution-content {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 300px;
}

.distribution-list {
  margin-top: 20px;
  flex: 1;
  overflow-y: auto;
  max-height: 180px;
  min-height: 150px;
}

.distribution-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #ebeef5;
}

.distribution-item:last-child {
  border-bottom: none;
}

.item-name {
  flex: 1;
  color: #606266;
  font-size: 14px;
}

.item-amount {
  width: 80px;
  text-align: right;
  color: #303133;
  font-weight: 500;
  font-size: 14px;
}

.item-percentage {
  width: 60px;
  text-align: right;
  color: #909399;
  font-size: 14px;
}

.table-wrapper {
  background: #fff;

  // table 背景颜色+padding10px
  .table-container {
    background: #fff;
    padding: 10px;
    height: calc(100% - 52px);
    margin-top: 10px;

    .table {
      height: calc(100% - 52px);

      ::v-deep .el-table__body-wrapper {
        height: calc(100% - 52px);
        overflow-y: auto;
      }
    }

    //::v-deep .el-table__body-wrapper {
    //  height: calc(100% - 68px);
    //  overflow-y: auto;
    //}

    // table内容部分下边距和最小高度
    .el-table {
      margin-bottom: 10px;
      min-height: 264px;
    }
  }
}

//.pagination {
//  padding: 20px 10px;
//  background: #fff;
//  text-align: right;
//
//  ::v-deep .el-pagination__total {
//    float: left;
//  }
//}

/* 响应式布局：当屏幕宽度小于1200px时 */
@media (max-width: 1200px) {
  .content .el-row {
    flex-direction: column;
  }

  .left-panel,
  .right-panel {
    min-height: auto;
  }

  .table-wrapper {
    min-height: 400px;
  }
}
</style>
